<template>
    <div>
      <!-- 全部设备 -->
      <device-list deviceType=""></device-list>
    </div>
  </template>
  
  <script>
  import DeviceList from "./DeviceList.vue";
  export default {
    components: {
      DeviceList,
    },
  };
  </script>
  
  <style lang="scss" scoped></style>
  